/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  orange_10: '#fce8e1',
  orange_20: '#fcd0c0',
  orange_30: '#fab69d',
  orange_40: '#f59776',
  orange_50: '#ed774c',
  orange_60: '#e05b2b',
  orange_70: '#cf4615',
  orange_80: '#bd3909',
  orange_90: '#a83207',
  orange_100: '#942c06',

  a11y_text_light: [70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/orange.js